// utils.js

/**
 * Μετατρέπει ημερομηνία από "YYYY-MM-DD" σε "DD/MM/YYYY"
 * @param {string} isoDate - Η ημερομηνία σε μορφή "2024-12-06"
 * @returns {string} - Η ημερομηνία σε μορφή "06/12/2024"
 */
export const formatDateForCSV = (isoDate) => {
    if (!isoDate || typeof isoDate !== 'string') return '';
    const [year, month, day] = isoDate.split('-');
    return `${day}/${month}/${year}`;
  };
  